import get from 'lodash/get';
import { types } from './actionTypes';
import getGeneric from '../../../actions/getGeneric';

export const startFetchingRoomRankerData = () => ({
  type: types.SET_ROOM_RANKER_DATA_LOADING,
  payload: { loading: true }
});

export const endFetchingRoomRankerData = () => ({
  type: types.SET_ROOM_RANKER_DATA_LOADING,
  payload: { loading: false }
});

export const fetchRoomRankerData = (payload) => (dispatch) => {
  const { widgetId, filters, benchmark, sort, offset, limit } = payload;

  dispatch(startFetchingRoomRankerData());

  dispatch(
    getGeneric({
      requestBody: {
        data_tag: 'DATATAG_DELIGHTIQ_GET_AGGREGATED_DATA_V2',
        request_data: {
          widget_id: widgetId,
          filters: {
            ...(filters || {}),
            offset,
            limit
          },
          sort,
          benchmark
        }
      },
      onSuccess: (response) => {
        const raw = get(
          response,
          'api_response.APITAG_DELIGHTIQ_AGGREGATE_DATA_V2',
          {}
        );

        const status = get(raw, 'status', '');

        if (status === 'SUCCESS') {
          const tableData = get(raw, 'data.metric_data', []);
          const columns = get(raw, 'data.columns', []);
          const totalRecords = get(raw, 'data.total_records', 0);

          dispatch({
            type: types.SAVE_ROOM_RANKER_TABLE_DATA,
            payload: {
              widgetId,
              tableData,
              tableColumns: columns,
              totalRecords
            }
          });
        } 
        dispatch(endFetchingRoomRankerData());
      },
      onError: () => {
        dispatch(endFetchingRoomRankerData());
      }
    })
  );
};